export function cleanProductGateFilter(filter, productGateRange, productGateSort) {
    const filtered = Object.fromEntries(
        Object.entries(filter)
            .filter(([_, v]) => v != null && v !== '')
    );
    filtered.productGateRange = productGateRange;
    filtered.productGateSort = productGateSort;
    return filtered;
}